'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var SimpleInput = require('./SimpleInput.js');
var alloyInput_module = require('./alloy-input.module.scss.js');
var DeleteIcon = require('../alloy-icon/DeleteIcon.js');

var FileInput = function (_a) {
    var _b = _a.error, error = _b === void 0 ? '' : _b, file = _a.file, id = _a.id, label = _a.label, onChange = _a.onChange, removeHandler = _a.removeHandler, setError = _a.setError, validator = _a.validator, _c = _a.value, value = _c === void 0 ? '' : _c, _d = _a.wrapperClassName, wrapperClassName = _d === void 0 ? '' : _d, props = tslib.__rest(_a, ["error", "file", "id", "label", "onChange", "removeHandler", "setError", "validator", "value", "wrapperClassName"]);
    var _e = useDefaultInternalState.default(error, setError), errorState = _e[0], setErrorState = _e[1];
    var changeHandler = function (e) {
        if (validator) {
            var result = validator(e.target.value);
            setErrorState(result);
        }
        else {
            setErrorState();
        }
        if (onChange) {
            onChange(e);
        }
    };
    return (jsxRuntime.jsx(jsxRuntime.Fragment, { children: jsxRuntime.jsx("div", tslib.__assign({ className: "file-input__wrapper ".concat(wrapperClassName ? wrapperClassName : '') }, { children: file ? (jsxRuntime.jsxs("span", tslib.__assign({ className: "".concat(alloyInput_module.default['file-input__file']) }, { children: [jsxRuntime.jsx(AlloyButton.AlloyButton, tslib.__assign({ buttonType: "ghost", type: "button", className: "".concat(alloyInput_module.default['file-input__button'], " ps-0"), onClick: removeHandler }, { children: jsxRuntime.jsx(DeleteIcon.default, { className: "".concat(alloyInput_module.default['file-input__icon']) }) })), file] }))) : (jsxRuntime.jsx("div", tslib.__assign({ className: "custom-file" }, { children: jsxRuntime.jsx(SimpleInput.default, tslib.__assign({ className: "".concat(alloyInput_module.default['alloy-custom-file-input']), type: "file", onChange: changeHandler, value: value, error: errorState, label: label, labelClassName: "btn btn-ghost btn-sm ps-0", id: id }, props)) }))) })) }));
};
var FileInput$1 = FileInput;

exports.default = FileInput$1;
//# sourceMappingURL=FileInput.js.map
